// Turns the core's error codes into display strings. The defaults are English so
// a consumer that passes nothing still renders; apps override with their i18n.

import { ERROR_CODES } from '../core/validation';

// Defaults match the strings the screens shipped with, so a consumer that passes
// nothing still renders correctly. Apps override these with their own i18n.
export const DEFAULT_TEXTS = {
  cantBeBlank: "Can't be blank",
  invalidEmail: 'Invalid email',
  invalidFormat: (error) => `Invalid format ${error}`,
  invalidExtension: 'Invalid extension (Allowed: xml, pdf or json)',
  extensionMismatch: (ext) => `Invalid extension: ${ext}. Check File Type.`,
  jsonEditor: 'JSON Editor',
  encrypted: 'Encrypted',
  headerKey: 'key',
  headerValue: 'value',
  add: 'Add',
  removeEntry: 'Remove entry',
};

export const withDefaultTexts = (texts) => ({ ...DEFAULT_TEXTS, ...texts });

export const messageForError = (error, texts) => {
  if (!error) return '';

  const resolved = withDefaultTexts(texts);

  switch (error.code) {
    case ERROR_CODES.BLANK:
      return resolved.cantBeBlank;
    case ERROR_CODES.INVALID_EMAIL:
      return resolved.invalidEmail;
    case ERROR_CODES.INVALID_FORMAT:
      return resolved.invalidFormat(error.params.error);
    case ERROR_CODES.INVALID_EXTENSION:
      return resolved.invalidExtension;
    case ERROR_CODES.EXTENSION_MISMATCH:
      return resolved.extensionMismatch(error.params.ext);
    default:
      return '';
  }
};
